import type { EventBusSubscribeHandler } from '@/services/EventService/types/EventBusSubscribeHandler';
import type { EventPayload } from '@/services/EventService/types/EventPayload';
import { useCallback, useEffect } from 'react';
import EventService from '@/services/EventService/EventService';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export const useEventEffect = <E extends new (...args: any[]) => EventV2<any>>(
  event: E | E[],
  handler: EventBusSubscribeHandler<EventPayload<E>>,
  dependencies: any[] = [],
) => {
  const onDispatchedHandler = useCallback(
    (payload: EventPayload<E>) => {
      handler(payload);
    },
    [handler],
  );

  useEffect(() => {
    if (Array.isArray(event)) {
      event.forEach((e) => EventService.subscribe(e, onDispatchedHandler));
      return () => event.forEach((e) => EventService.unsubscribe(e, onDispatchedHandler));
    } else {
      EventService.subscribe(event, onDispatchedHandler);
      return () => EventService.unsubscribe(event, onDispatchedHandler);
    }
  }, dependencies);
};
